"use client"

import {useEffect, useState} from 'react';
import {Paths} from "@/types/Paths";
import {pathsRequest} from "@/utils/api/Paths";
import {useLocale} from "use-intl";

const usePathsData = () => {
  const locale = useLocale()
  const [data, setData] = useState<Paths | undefined>(undefined)
  useEffect(() => {
    const fetchData = async () => {
      const fetched = await pathsRequest(locale)
      if (fetched) {
        setData(fetched)
      }
    }
    if (!data) {
      fetchData()
    }
  }, [locale, data]);

  return data
};

export default usePathsData;
